import Enum from "../../../enums/Enum";

const EnumBillTypeShort = new Enum({
    SELF_PAY: "SP",
    DIRECT_BILLING: "DB"
});

export default EnumBillTypeShort;